module.exports = {
      id: "icon-play-usage",
      viewBox: "0 0 17.037 21.916",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }